<ng-container *ngIf="primary; else standardIcon">
  <b class="metric-value" *ngIf="showValue && displayValue">
    {{displayValue}}
  </b>
  <i style="margin-left: 5px; font-size: 1.1em" [ngClass]="[
                getArrowClass(),
                getBgColorClass()
              ]"></i>
</ng-container>

<ng-template #standardIcon>
  <span *ngIf="showValue && displayValue" [ngClass]="getTextColorClass()">{{displayValue}}</span>
  <i style="margin-left: 5px; font-size: 1.1em" [ngClass]="[
                getArrowClass(),
                getBgColorClass()
              ]"></i>
</ng-template>